import {
  ReportAggregationSort,
  ReportAggregationType,
  ReportBucketAggregation,
  ReportDateHistogramType,
  ReportMetric,
  ReportMetricType,
  ReportOrderType,
  ReportValue,
} from '@driftt/api-types'

import { createMetric, createOrder, createSort } from './creators'
import { ISortConfig } from './types'

export default class AggregationBuilder {
  public property: string
  public type: ReportAggregationType
  public metrics: ReportMetric[]
  public size: number
  public sorts: ReportAggregationSort[]
  public aggregations: ReportBucketAggregation[]
  public interval?: ReportDateHistogramType | number
  public minValue?: ReportValue
  public maxValue?: ReportValue
  public missingValue?: ReportValue

  constructor(
    property: string,
    type: ReportAggregationType = ReportAggregationType.TERMS
  ) {
    this.property = property
    this.type = type
    this.size = 0
    this.aggregations = []
    this.sorts = []
    this.metrics = []
  }
  public withDocCount() {
    this.metrics.push({ type: 'DOC_COUNT' })
    return this
  }
  public withAggregation(aggregation: ReportBucketAggregation) {
    this.aggregations.push(aggregation)
    return this
  }
  public withSize(size: number) {
    this.size = size
    return this
  }
  public withMissingValue(missingValue: ReportValue) {
    this.missingValue = missingValue
    return this
  }
  public withMetric(
    property: string,
    type: ReportMetricType,
    metricType?: ReportMetricType,
    options: any = null
  ) {
    this.metrics.push(createMetric(property, type, metricType, options))
    return this
  }
  public withMetricObject(...metrics: ReportMetric[]) {
    this.metrics.push(...metrics)
    return this
  }
  public withInterval(interval: number | ReportDateHistogramType) {
    this.interval = interval
    return this
  }
  public withMinMax(minValue: ReportValue, maxValue: ReportValue) {
    this.minValue = minValue
    this.maxValue = maxValue
    return this
  }
  public withSort(sortConfig?: ISortConfig) {
    if (sortConfig) {
      const { metric, order } = sortConfig
      const sort = createSort(metric, order)
      if (sort && Array.isArray(sort)) {
        this.sorts = this.sorts.concat(sort)
      } else {
        this.sorts.push(sort)
      }
    }
    return this
  }
  public orderBy(order: ReportOrderType) {
    this.sorts = [createOrder(order)]
    return this
  }
  public build(): ReportBucketAggregation {
    const { aggregations, sorts, metrics, ...props } = this
    const agg: any = { ...props }

    if (aggregations.length > 0) {
      agg.aggregations = aggregations
    } else if (metrics.length > 0) {
      // omit metrics if sub-aggregation present
      agg.metrics = metrics
    }

    if (sorts.length > 0) {
      agg.sorts = sorts
    }
    return agg
  }
}
